import {Component, HostListener, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ButtonComponent} from '../button/button.component';
import {NgIf} from '@angular/common';
import {Card} from '../../../model/cards';
import {TextsComponent} from "../texts/texts.component";
import {Router} from '@angular/router';
import {scrollUp} from '../../../functions/scroll-up';
import {FeedbackService} from '../../../services/feedback-service';
import {Text} from '../../../model/text';

@Component({
  selector: 'app-offer-cell',
  imports: [
    ButtonComponent,
    NgIf,
    TextsComponent
  ],
  templateUrl: './offer-cell.component.html',
  standalone: true,
  styleUrl: './offer-cell.component.scss'
})
export class OfferCellComponent implements OnChanges, OnInit {
  constructor(private router: Router,
              public feedValue: FeedbackService) {
  }

  @Input() card: Card = new Card({
    img: '',
    style: '',
    text: [],
    title: [],
    button: false,
    id: 0,
  });
  @Input() height: string = '84vh';
  @Input() soloSlide: boolean = false;
  @Input() hover: boolean = false;
  @Input() paddingLeft: boolean = true;
  @Input() paddingRight: boolean = true;

  showButton = false;
  isMobile = false;
  isSmallMobile = false;
  buttonText: Text[] = [
    {text: ['Исследовать', 'Explore']}
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hover']) {
      this.showButton = this.hover;
    }
    this.checkScreenWidth();
  }

  ngOnInit(): void {
    this.checkScreenWidth();
    if (this.card.anotherButtonText !== undefined) {
      this.buttonText = this.card.anotherButtonText;
    }
  }

  checkScreenWidth() {
    this.isSmallMobile = window.innerWidth <= 570;
    if (window.innerWidth < 550) {
      this.isMobile = true;
      this.showButton = true;
    } else {
      this.isMobile = false;
      if (!this.hover) {
        this.showButton = false;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenWidth();
  }

  @HostListener('mouseover')
  onMouseOver() {
    if (this.isMobile || this.isSmallMobile) return;
    setTimeout(() => {
      this.showButton = true;
    }, 50);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.isMobile || this.isSmallMobile) return;
    setTimeout(() => {
      this.showButton = false;
    }, 50);
  }

  getBackground() {
    return `background-image: url("${this.card.img}")`;
  }

  navigateToLink(link: string, type: 'button' | 'container') {
    if (link == '') {
      return;
    }
    if (!this.isMobile && type == 'container') {
      return;
    }
    if (link.startsWith('http://') || link.startsWith('https://')) {
      window.open(link, '_blank', 'noopener,noreferrer');
    } else {
      let value: Text[] = [];
      if (this.card.feedValue !== undefined) {
        this.feedValue.setFeedbackValue(this.card.feedValue);
      }
      scrollUp();
      this.router.navigate([link]).then(r => r);
    }
  }

  get styleHeight() {
    if (!this.soloSlide || window.innerHeight < 800) {
      return 'height: 70vh;'
    }
    return 'height: 79vh;'
  }

  get stylePosition() {
    if (!this.isMobile || this.card.backgroundPosition === undefined) return '';
    return this.card.backgroundPosition;
  }

  protected readonly window = window;
}
